/* eslint-disable react/display-name */
// Packages
import React, { useRef } from 'react'
import dayjs from 'dayjs'
import ReactToPrint from 'react-to-print'

// Components
import ProfileAvatar from './ProfileAvatar'
import ProfileContact from './ProfileContact'
import ProfileDetails from './ProfileDetails'
// Antd
import { Button, Row, Col } from 'antd'
// Images
import logo from '../../public/img/logo.svg'

export type ApplicantOccupationQuestionAnswers = {
  OccupationQuestionAnswer: {
    answerText: string;
    certLicenseName: string;
    prependText: string;
    Occupation: {
      name: string;
    };
  };
};
export type ApplicantExperiences = {
  companyName: string;
  experienceYears: number;
  jobTitle: string;
  occupation: number;
  Occupation: {
    name: string;
  };
};

export type Applicant = {
  contact: string;
  email: string;
  whatsapp: string;
  avatar: string;
  education: string;
  Enum_EducationLevel: {
    display: string;
  };
  gender: 'Male' | 'Female';
  name: string;
  age: string;
  nationality: 'SG' | 'SP' | 'MY';
  locationOther: string;
  isStartWorkNow: boolean;
  dateOfBirth: string;
  Enum_WorkPass?: { display: boolean; workPass: boolean };
  isAvailable: boolean;
  languageSkills: string;
  ApplicantOccupationQuestionAnswers: ApplicantOccupationQuestionAnswers[];
  ApplicantExperiences: ApplicantExperiences[];
};
type Props = {
  applicant: Applicant | any;
  filename: string;
};

const ComponentToPrint = React.forwardRef<
  HTMLDivElement,
  { applicant: Applicant }
>(({ applicant }, ref) => {
	return (
		<div ref={ref} style={{ backgroundColor: '#fff', margin: 0, padding: 0 }}>
			<div style={{ margin: '1rem', float: 'right' }}>
				<img src={logo} alt="logo" />
			</div>
			<div style={{ margin: '1rem' }}>
				<Row justify="center" gutter={[16, 16]}>
					<Col xs={24}>
						<ProfileAvatar applicant={applicant} />
					</Col>
					<Col xs={24}>
						<ProfileContact applicant={applicant} />
					</Col>
					<Col xs={24}>
						<ProfileDetails applicant={applicant} />
					</Col>
					<Col xs={24}>
            Updated as of {dayjs().format('DD MMMM YYYY h:mm a')}
					</Col>
				</Row>
			</div>
			<div
				style={{
					padding: '.5rem 0',
					backgroundColor: '#ff6565',
					textAlign: 'center',
				}}
			>
				<h3 style={{ color: '#fff' }}>
          Findjobs is a tech platform that champions inclusive employment
				</h3>
			</div>
		</div>
	)
})

const ProfileDownload = ({ applicant, filename }: Props) => {
	const componentRef = useRef<HTMLDivElement>(null)

	return (
		<>
			<ReactToPrint
				trigger={() => (
					<Button
						type="primary"
						style={{
							borderRadius: '20px',
							paddingRight: '30px',
							paddingLeft: '30px',
							backgroundColor: '#ff6565',
						}}
					>
            Download Profile
					</Button>
				)}
				content={() => componentRef?.current}
				documentTitle={filename}
				bodyClass="tableRow"
			/>
			<div style={{ display: 'none' }}>
				<ComponentToPrint applicant={applicant} ref={componentRef} />
			</div>
		</>
	)
}

export default ProfileDownload
